/**
 * Result types for the two product-knowledge tools (PRD-0029):
 * `read_user_guide_page` and `search_user_guide`. No React, no IO — the
 * connected tool UIs and the presentational views both consume these.
 */

import { parseToolResult } from './parse-tool-result'

export interface ReadUserGuidePageArgs {
  slug: string
}

export interface UserGuideSection {
  heading: string
  anchor: string
}

export interface ReadUserGuidePageResult {
  status: 'ok' | 'unknown_slug' | 'unavailable' | 'error'
  slug?: string
  title?: string
  group?: string
  summary?: string
  /** Canonical docs URL for the language served (`/docs/<slug>` or `/docs/<locale>/<slug>`). */
  url?: string
  /** Language actually served; `not_translated` says it fell back to English. */
  locale?: string
  requested_locale?: string
  not_translated?: boolean
  sections?: UserGuideSection[]
  content?: string
  valid_slugs?: string[]
  error?: string
}

export interface SearchUserGuideArgs {
  term: string
}

export interface UserGuideHit {
  slug: string
  title: string
  locale: string
  heading: string | null
  anchor: string | null
  /** Page URL, with the section anchor when the hit sits under a heading. */
  url: string
  line: string
}

export interface SearchUserGuideResult {
  status: 'ok' | 'empty' | 'unavailable' | 'error'
  term?: string
  count?: number
  hits?: UserGuideHit[]
  error?: string
}

export const parseReadResult = parseToolResult<ReadUserGuidePageResult>
export const parseSearchResult = parseToolResult<SearchUserGuideResult>

/** A hit's link text: "Page title · Section heading" when it has a heading. */
export function hitLabel(hit: UserGuideHit): string {
  return hit.heading ? `${hit.title} · ${hit.heading}` : hit.title
}
